import enLang from './entries/en';
import arLang from './entries/ar';

const AppLocale = {
  en: enLang,
  ar: arLang,
};

export default AppLocale;
